import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';

export const getSession = async () => {
  const apiURL = `${API_HOST}/session`;
  const { token, userID } = useCurrentUser();
  //  console.log('here is the token: ', token);
  //  console.log('here is the userID: ', userID);
  try {
    if (!userID || !token) {
      return false;
    }
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
        'Content-Type': 'application/json',
      },
    });

    // console.log('here is the data from getSession: ', data);
    return data;
  } catch (error) {
    console.error('Error fetching session data:', error);
    return null;
  }
};

// export const getUserRole = async () => {
//   const apiURL = `${API_HOST}/sessions/user_role`;
//   const { token, userID } = useCurrentUser(); // Assuming useCurrentUser provides the token

//   try {
//     const response = await axios.get(apiURL, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });

//     return response.data.userRole;
//   } catch (error) {
//     console.error('Error fetching user role:', error);
//     console.log('here is the super fun token: ', token)
//   }
// };
